import { Form, Input, InputNumber, Typography } from 'antd'
import FormSection from 'components/form-section'
import React from 'react'

const units = {
  reference_pressure: {
    FIELD: 'psia',
    METRIC: 'bar'
  },
  rock_compressibility: {
    FIELD: '/psi',
    METRIC: '1/bar'
  }
}

const RockTable = () => {
  const simulationUnit = Form.useWatch(["GENERAL", "unit"])

  return (
    <FormSection title="Rock">
      <div className="vstack gap-2">
        <div className="hstack gap-2 align-items-center">
          <Typography.Text className="text-light" style={{ width: 200 }}>
            Reference Pressure
          </Typography.Text>
          <Form.Item name={['PVT', 'rock', 'reference_pressure', 'value']} className="mb-0">
            <InputNumber className="w-100" step={0.01} />
          </Form.Item>
          <Typography.Text className="text-light">
            {units.reference_pressure[simulationUnit] ?? ''}
          </Typography.Text>
        </div>
        <div className="hstack gap-2 align-items-center">
          <Typography.Text className="text-light" style={{ width: 200 }}>
            Rock Compressibility
          </Typography.Text>
          <Form.Item name={['PVT', 'rock', 'rock_compressibility', 'value']} className="mb-0">
            <Input />
          </Form.Item>
          <Typography.Text className="text-light">
            {units.rock_compressibility[simulationUnit] ?? ''}
          </Typography.Text>
        </div>
      </div>
    </FormSection>
  )
}

export default RockTable